<template>
  <div >

    <!--Banner-->
    <section>
      <div class="topBanner"></div>
    </section>

    <!--main section-->
    <section class="bg gridpad">
      <v-row>
        <v-col cols="12" lg="6" class="txt-j d-flex align-center justify-start">
          <div class="">
            <h2 class="subtitle">{{ $t('section.title') }}</h2>
            <h3 class="mt-4 sSlogan">{{$t('section.subtitle') }}</h3>
            <p class="pb-8" v-html="$t('section.txt')"></p>
            <div class="cookieLink "><p @click="openCookie()" class="cookieLink"> Mes témoins</p></div>
            <div class="cookieLink pr-5"><p @click="navigateToPolicy()" class="cookieLink">Politique de confidentialiter</p></div>
            <div class="d-flex py-2"><img class="iconSize" src="/Resources/images/icon/location.png"/><p class="join" v-html="$t('section.address')"></p></div>
            <div class="d-flex py-2"><img class="iconSize" src="/Resources/images/icon/phone.png"/><p class="join" v-html="$t('section.phone')"></p></div>
            <div class="d-flex py-2"><img class="iconSize" src="/Resources/images/icon/mail.png"/><a href="mailto:info@bissonservice.com"><p class="linkMail" v-html="$t('section.mail')"></p></a></div>
          </div>
        </v-col>
        <v-col cols="12" lg="6" class="txt-j d-flex align-center justify-lg-end justify-start">
          <div>
            <p v-html="$t('section.dateNumber')"></p>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--section4 Map-->
    <section>
      <iframe class="map" style="border:0; margin-bottom: -4px;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2777.872604134693!2d-72.518639108993!3d45.87385833146289!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cc813e3b04681df%3A0x2225e244fdb72350!2s924%20Rue%20Saint-Pierre%2C%20Drummondville%2C%20QC%20J2C%204A5!5e0!3m2!1sfr!2sca!4v1691589950088!5m2!1sfr!2sca"></iframe>
    </section>
  </div>
</template>

<style scoped>
  p {font-size: 18px; color: rgba(var(--menuColor),0.6);}
  .map {width:100%; height:calc(150px + 20vw);}
  .gridpad {padding: 100px 200px 0px 200px;}
  .sSlogan {color: rgba(var(--menuColor),0.8); font-weight: 500; font-size: 22px; padding: 0px 0px 30px 0px;}
  .subtitle {line-height: 25px;}
  .topBanner {height: 450px; background-image: url('../../public/Resources/images/Banner/bannerContactUs.jpg'); background-position: center; background-position-y: 65%; background-repeat: no-repeat; background-size: cover;}
/*#region section4 Quality*/ 
  .iconSize {height:16px; width:16px; margin: 5px 0px 0px 0px;}
  .bg{background-color: rgb(var(--tierce2)); height:600px;}
  .join {font-size: 18px; color: rgb(var(--secondary)); font-weight: 700; padding: 0px 0px 0px 10px;}
  .linkMail {font-size: 18px; color: rgb(var(--secondary)); font-weight: 700; padding: 0px 0px 0px 10px;}
  .linkMail:hover {color: rgb(var(--primary));}
  .cookieLink { color: rgb(var(--secondary)) ; text-decoration: none ; cursor: pointer;}
    .cookieLink:hover { text-decoration: underline !important; color: rgb(var(--primary));}
  /*#endregion*/ 

@media handheld, only screen and (max-width: 600px) {
  .textPadLeft { padding: 200px 30px 0px 30px !important;}
  
}

@media handheld, only screen and (max-width: 960px) {
  .gridpad {padding: 30px !important;}
}

@media handheld, only screen and (max-width: 1279px) {
  .gridpad {padding: 50px 200px 50px 200px;}
  .bg{background-color: rgb(var(--tierce2)); height:100%;}
  
}
@media handheld, only screen and (max-width: 1378px) {}
</style>

<script>
    import pageTranslations from '../../public/Resources/i18N/contact.json';
  export default {
    name: 'contact',
    data: () => ({}),
    mounted() {
      this.$i18n.mergeLocaleMessage('fr', pageTranslations.fr);
      this.$i18n.mergeLocaleMessage('en', pageTranslations.en);

    },
    components: {},
  }
</script>
  
  